import { DokumentStavka } from './dokument-stavka';
import { BaseDataService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent } from 'yt-ng-framework';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'yt-dokument-stavka-update',
  templateUrl: './dokument-stavka-update.component.html'
})
export class DokumentStavkaUpdateComponent extends BaseUpdateComponent<DokumentStavka> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }
  
  ngOnInit() {
    super.ngOnInit();
    this.IDProcessed
    .subscribe((value) => {
      this.baseFormGroup.patchValue({Porez: 0});
    })  
  }

  editMode:boolean=false;
  SaveMaster(qq){}
  Cancel(){}
}
